<div class="table-container">
    <h1>Validators</h1>
    <table mat-table [dataSource]="matDatasource" class="mat-elevation-z8 container-fluid">

        <!-- Column with check box for validator selection -->
        <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef> Is Validator Selected? </th>
            <td mat-cell *matCellDef="let row">
                <mat-checkbox (change)="toggleSelection(row)"
                              [checked]="selection.isSelected(row)"
                              [disabled]="isReadOnly"></mat-checkbox>
            </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef> Validator name </th>
            <td mat-cell *matCellDef="let element"> {{element.label}} </td>
        </ng-container>

        <!-- Value Column -->
        <ng-container matColumnDef="value">
            <th mat-header-cell *matHeaderCellDef> Validator Value </th>
            <td mat-cell *matCellDef="let element">
                <input *ngIf="isNumberType(element.value)"
                       (change)="changed(element, 'value', $event.target.value)" required="false" [disabled]="isNotEditable(element)" [readonly]="isNotEditable(element)" value="{{element.value}}" type="number"/>
                <input *ngIf="isStringType(element.value)"
                       (change)="changed(element, 'value', $event.target.value)" required="false" [disabled]="isNotEditable(element)" [readonly]="isNotEditable(element)" value="{{element.value}}" type="text"/>
                <mat-slide-toggle *ngIf="isBooleanType(element.value)" checked [disabled]="isNotEditable(element)"></mat-slide-toggle>
            </td>
        </ng-container>

        <!-- Message Column -->
        <ng-container matColumnDef="message">
            <th mat-header-cell *matHeaderCellDef> Validator Message </th>
            <td mat-cell *matCellDef="let element">
                <input (change)="changed(element, 'message', $event.target.value)" required="false" [disabled]="true" [readonly]="true" value="{{element.message}}" type="text"/>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</div>
